module.exports = __webpack_public_path__ + "img/block6-card9.4d168604.svg";